module.exports = __webpack_public_path__ + "static/media/20191214_160738.8cf5f12a.jpg";